import React from "react";
import { Col, Container } from "reactstrap";

const DOWNLOAD_URL = "/downloads/iXiMultiScreen.zip";
const APP_VERSION = "1.0.0";

const IXiMultiScreenDownload = () => {
    const isConfigured = DOWNLOAD_URL !== "#";

    return (
        <div className="page-content">
            <Container fluid>
                <Col lg={12}>
                    <div className="card">
                        <div className="card-body text-center">

                            <h1 className="text-primary mb-4">
                                iXiMultiScreen
                            </h1>
                            <p className="text-secondary mb-4">
                                Application de diffusion multi-écrans. Téléchargez la dernière version ci-dessous.
                            </p>

                            <p className="mb-4">
                                <span className="badge bg-info me-2">Version {APP_VERSION}</span>
                                <span className="badge bg-secondary">Windows (.exe)</span>
                            </p>

                            {isConfigured ? (
                                <a
                                    href={DOWNLOAD_URL}
                                    download
                                    className="btn btn-primary btn-lg"
                                >
                                    <i className="mdi mdi-download me-2"></i>
                                    Télécharger iXiMultiScreen
                                </a>
                            ) : (
                                <p className="text-warning">
                                    ⚠️ Le lien de téléchargement n'est pas encore configuré.
                                </p>
                            )}

                        </div>
                    </div>
                </Col>
            </Container>
        </div>
    );
};

export default IXiMultiScreenDownload;
